module.exports = __webpack_public_path__ + "static/media/osborne@3x.56949c07.jpg";